export default __webpack_public_path__ + "static/media/codeBgLow1.bd0332b3.jpg";